module.exports = __webpack_public_path__ + "img/hp.c53c7f28.svg";